import { render, staticRenderFns } from "./IndividualVatInfoSelector.vue?vue&type=template&id=32d0c8d7"
import script from "./IndividualVatInfoSelector.vue?vue&type=script&lang=ts"
export * from "./IndividualVatInfoSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports